import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import AssetName from "./Common/AssetName";
import Modal from "../../ui/modal";
import SignatureModal from "../Modals/SignatureModal";
import { deleteSigner, fetchSignerList } from "../../../store/actions/editorActions";
import { Icon } from "../../ui/icon";
import MoreOption from "../../ui/MoreOption";
import DeleteElemModal from "../Modals/DeleteElemModal";
import SignatureLoader from "../../ui/loader/SignatureLoader";
import SignerDetailsModal from "../Modals/SignerDetailsModal";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import { Tooltip } from "reactstrap";
import { updateProposalModuleRecord } from "../../../store/actions/companyActions";

let style = Object.assign({}, global);

const SignatureDetails = props => {
  const nameRef = useRef(null);
  const emailRef = useRef(null);

  const [tooltipOpen, setTooltipOpen] = useState();

  const optionList = [
    {
      label: "Edit Details",
      icon: "ui-effects",
      class: props.isDocumentSigned ? "disabled" : "",
      clickFunc: () => {
        props.setActiveSignatureId(props.signature._id), props.toggleModal();
      },
    },
    {
      label: "Remove as Signer",
      icon: "ui-trash",
      class: props.isDocumentSigned ? "disabled" : "",
      clickFunc: () => {
        props.setActiveSignatureId(props.signature._id), props.toggleDeleteModal();
      },
    },
    {
      label: "Submited Details",
      icon: "ui-signature",
      class: props.signature.status !== "signed" || props.isDocumentSigned === "declined" ? "disabled" : "",
      clickFunc: () => {
        props.setActiveSignatureId(props.signature._id), props.toggleDetailsModal();
      },
    },
  ];

  const toggle = () =>
    setTooltipOpen(
      !tooltipOpen &&
        (nameRef.current.scrollWidth > nameRef.current.offsetWidth ||
          emailRef.current.scrollWidth > emailRef.current.offsetWidth)
    );

  return (
    <>
      <li
        className={cx(
          style["signature-item"],
          style["d-flex"],
          style["align-items-center"],
          style["justify-content-between"],
          style["skeleton-loader-area"]
        )}>
        <div className={cx(style["user-info"], style["d-flex"], style["align-items-center"])}>
          <div>
            <div className={cx(style["user-icon"], style[`signature-${props.idx}`])}>
              <Icon icon="ui-user"></Icon>
            </div>
          </div>
          <div className={cx(style["ms-2"], style["user-details"])} id={`tooltip-${props.idx}`}>
            <h6 className={cx(style["text-truncate"], style["mb-0"])} ref={nameRef}>
              {props.signature.name}
            </h6>
            <div className={cx(style["text-muted"], style["text-truncate"], style["font-13"])} ref={emailRef}>
              {props.signature.email}
            </div>
          </div>
          <Tooltip
            className="hover-tooltip"
            placement="bottom"
            isOpen={tooltipOpen}
            target={`tooltip-${props.idx}`}
            toggle={toggle}
            boundariesElement={document.getElementById("app")}>
            {props.signature.name}
            <div className={cx(style["font-13"])}>{props.signature.email}</div>
          </Tooltip>
        </div>

        <MoreOption options={optionList ?? []} dropdownClass="more-action" />
      </li>
    </>
  );
};

const Signature = props => {
  const dispatch = useDispatch();

  let { isDocumentSigned } = useContext(EditorContext);

  const documentId = useSelector(state => state.document?.documentDetails?.data?.id);

  const [assetLoad, setAssetLoad] = useState();
  const [signatureList, setSignatureList] = useState();
  const [activeSignatureId, setActiveSignatureId] = useState();
  const [showModalStatus, setShowModalStatus] = useState(false);
  const [isFormSave, setIsFormSave] = useState();
  const [showDeleteModalStatus, setShowDeleteModalStatus] = useState(false);
  const [availableEmailList, setAvailableEmailList] = useState();
  const [showDetailsModalStatus, setShowDetailsModalStatus] = useState(false);
  const [targetSignatureFormId, setTargetSignatureFormId] = useState();

  const modalData = {
    title: `Remove as Signer`,
    body: `Are you sure to remove the signer? This action can’t be reversed.`,
    btnLabel: "Remove",
  };

  //Function to show hide the signer modal
  const toggleModal = () => {
    setShowModalStatus(!showModalStatus);
  };

  //Function to show hide the signer delete modal
  const toggleDeleteModal = () => {
    setShowDeleteModalStatus(!showDeleteModalStatus);
  };

  //Function to show hide the signer details modal
  const toggleDetailsModal = () => {
    setShowDetailsModalStatus(!showDetailsModalStatus);
  };

  //Function to fetch signature list
  const dispatchSignerList = () => {
    setAssetLoad(true);
    dispatch(fetchSignerList(documentId)).then(r => {
      setSignatureList(r.data.data);
      setAssetLoad(false);
    });
  };

  //Function to remvoe signature
  const removeSigner = () => {
    dispatch(deleteSigner(activeSignatureId)).then(r => {
      dispatchSignerList();

      const match = signatureList.find(item => item._id === activeSignatureId);
      const signatureFormId = match?.signatureForm?._id || null;
      if (signatureFormId) {
        setTargetSignatureFormId({ inuse: false, form_id: signatureFormId });
      }
    });
  };

  // call signer list first time render
  useEffect(() => {
    dispatchSignerList();
  }, []);

  // call signer list after form save
  useEffect(() => {
    if (isFormSave) {
      dispatchSignerList();
      setIsFormSave(false);
    }
  }, [isFormSave]);

  // collect signer email
  useEffect(() => {
    if (signatureList?.length > 0) {
      let emaillist = [];
      signatureList.forEach(item => {
        emaillist.push(item.email);
      });
      setAvailableEmailList(emaillist);
    } else setAvailableEmailList();
  }, [signatureList]);

  useEffect(() => {
    if (isDocumentSigned === "declined") {
      dispatchSignerList();
    }
  }, [isDocumentSigned]);

  useEffect(() => {
    if (targetSignatureFormId) {
      let payload;
      if (targetSignatureFormId.inuse) {
        payload = {
          signature_form: {},
        };
        payload.signature_form.in_use = true;
      } else {
        const isPresent = signatureList.some(
          item => item.signatureForm && item.signatureForm._id === targetSignatureFormId.form_id
        );
        payload = {
          signature_form: {},
        };
        payload.signature_form.in_use = isPresent;
      }
      // dispatch(updateProposalModuleRecord("signature_forms", targetSignatureFormId.form_id, payload));
    }
  }, [targetSignatureFormId, signatureList]);

  return (
    <>
      <div className={cx(style["editor-asset-inner"], style["signature-asset"])}>
        <AssetName handleWidgetAction={props.handleWidgetAction} assetName={props.assetName} showTooltip={true} />
        <div className={cx(style["pe-20"], style["mb-3"])}>
          <span
            className={cx(style["btn"], style["btn-border"], style["color-black"], style["font-15"], {
              [style["disable"]]: signatureList?.length === 10 || isDocumentSigned,
            })}
            onClick={() => {
              toggleModal(), setActiveSignatureId(false);
            }}>
            <Icon icon="ui-user" additionalclass={"me-2 font-base"} />
            Add Signer
          </span>
        </div>

        <div className={cx(style["customScroll"], style["scroll-Y"], style["assets-wrapper"], style["pe-0"])}>
          <ul className={cx(style["signature-list"])}>
            {assetLoad && <SignatureLoader count={8} />}

            {!assetLoad &&
              signatureList?.length > 0 &&
              signatureList.map((signature, index) => (
                <SignatureDetails
                  key={index}
                  idx={index}
                  signature={signature}
                  setActiveSignatureId={setActiveSignatureId}
                  toggleModal={toggleModal}
                  toggleDeleteModal={toggleDeleteModal}
                  toggleDetailsModal={toggleDetailsModal}
                  isDocumentSigned={isDocumentSigned}
                />
              ))}
          </ul>
        </div>
      </div>

      {showModalStatus && (
        <Modal
          showModal={showModalStatus}
          setShowModal={setShowModalStatus}
          component={SignatureModal}
          modalClassName={"signature-modal"}
          setIsFormSave={setIsFormSave}
          activeSignatureId={activeSignatureId}
          availableEmailList={availableEmailList}
          targetSignatureFormId={targetSignatureFormId}
          setTargetSignatureFormId={setTargetSignatureFormId}
        />
      )}

      {showDeleteModalStatus && (
        <Modal
          showModal={showDeleteModalStatus}
          setShowModal={setShowDeleteModalStatus}
          component={DeleteElemModal}
          modalTitle={modalData?.title}
          modalBody={modalData?.body}
          modalButtonLabel={modalData?.btnLabel}
          deleteElem={removeSigner}
          closeModal={toggleDeleteModal}
        />
      )}

      {showDetailsModalStatus && (
        <Modal
          showModal={showDetailsModalStatus}
          setShowModal={setShowDetailsModalStatus}
          component={SignerDetailsModal}
          modalClassName={"signature-submitted-modal"}
          activeSignatureId={activeSignatureId}
          className={"modal-lg"}
        />
      )}
    </>
  );
};

export default Signature;
